export enum Chat {
  PatientApp = 1, // 1 needed For backwards compatibility after Alberta Chat was removed
}
